export const featureFlags = {
  USE_KEYCLOAK: import.meta.env.VITE_USE_KEYCLOAK === "true",
  RH_USE_MOCKS: import.meta.env.VITE_RH_USE_MOCKS === "true",
};
